import { render, staticRenderFns } from "./OnSale.vue?vue&type=template&id=01e7c252&"
import script from "./OnSale.vue?vue&type=script&lang=js&"
export * from "./OnSale.vue?vue&type=script&lang=js&"
import style0 from "./OnSale.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports